module.exports = {

  prepareHtmlLoad (elemId, url) {
    return function () {
      $.get(url, (data) => $(elemId).html(data));
    };
  },

  prepareWidget (elemId, widget, options) {
    return function () {
      $(elemId)[widget](options);
    };
  },

  cheapestVacation() {
    return function() {
      $.getJSON( "/sys/bloky/homepage/hp-dovolena-nabidky.json", function( data ) {
        $('#dovolena .content div:first-child').hide()
        var main = data.boxViewData
        var childObject = main.content
        for (var property in main) {
          if (main.hasOwnProperty(property)) {
            var container = main[property]
            if(typeof(container) === 'object') {
              var count = 5;
              for (var key in container) {
                var obj = container[key]
                if(count > 0) {
                  const item = `
                    <div class="item">
                      <div class="destination pull-left">
                        <a href="${obj.url}">${obj.title}</a>
                      </div>
                      <div class="price pull-right">
                        <a href="${obj.url}">${obj.price}</a>
                      </div>
                    </div>`
                  $('#dovolena .content').append(item)
                  // $('#dovolena .content').append("<div class='item'><div class='destination pull-left'><a href=" + obj.url + ">" + obj.title + "</a></div><div class='price pull-right'><a href=" + obj.url + ">" + obj.price + "</a></div></div>")
                }
                count--
              }
            }
          }
        }
      }).error(function() {
        console.log("Data pro box s nabídkami nejlevnější dovolené nejsou dostupné.");
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/global/helpers.js